export default "__VITE_ASSET__Clzh75lL__"